import { bootstrap } from './src/bootstrap';

// eslint-disable-next-line @trello/no-module-logic
bootstrap();
